import React, { useMemo } from "react";
import { PROGRAM_SPECIFIC_NAMES } from "../../Helpers/constants";
import DxpPageShell from "../Common/StandaloneFormViews/DxpPageShell";
import { createDxpClickHandler } from "../../Helpers/utils";
import {
  DxpBodyText,
  DxpFooterRow,
  DxpHeading,
  DxpMessageCard,
  DxpNarrowColumn,
  DxpPrimaryButton,
} from "../dxpStandaloneUi";
import DxpRegistrationTopHeader from "../DxpRegistrationTopHeader";

const PROGRAM = "DXP";

function PendingApproval() {
  const onAction = useMemo(() => createDxpClickHandler(), []);
  const adobeName = PROGRAM_SPECIFIC_NAMES.DXP.partnerProgram.adobeProgramName;

  return (
    <>
      <DxpRegistrationTopHeader program={PROGRAM} />

      <DxpPageShell requireCommonHeaders>
        <div className="dxp-static-message-outer">
          <DxpNarrowColumn>
            <DxpMessageCard className="dxp-message-card--min-h-350">
              <DxpHeading>Your application is pending approval.</DxpHeading>
              <DxpBodyText>
                We are reviewing your application for the {adobeName}. We will
                notify you via email once the review is complete.
              </DxpBodyText>
              <DxpBodyText>
                If you have questions about your application status, please
                contact our support team.
              </DxpBodyText>
              <DxpFooterRow>
                <DxpPrimaryButton
                  label="Contact Support"
                  onPress={() => onAction({ actionType: "email" })}
                  variant="accent"
                  className="dxp-wizard-cta-inverse"
                />
              </DxpFooterRow>
            </DxpMessageCard>
          </DxpNarrowColumn>
        </div>
      </DxpPageShell>
    </>
  );
}

export default PendingApproval;
